import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { BloqueioConcessoesService } from './bloqueio-concessoes.service';

export const bloqueioInterceptor: HttpInterceptorFn = (request, next) => {
  const concessoes = inject(BloqueioConcessoesService);
  const url = new URL(request.url, location.origin);
  if (
    url.origin !== location.origin ||
    !url.pathname.startsWith('/frontend-api/') ||
    !['POST', 'PUT', 'PATCH', 'DELETE'].includes(request.method)
  ) {
    return next(request);
  }
  return next(
    request.clone({
      setHeaders: { 'X-Slice-Bloqueios': JSON.stringify(concessoes.provas()) },
    }),
  );
};
